<template>
  <div>
    <v-dialog persistent v-model="dialog" width="600">
      <v-card>
        <v-card-title>
          <span class="headline">Gestion des conditions de paiement</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="T_Libelle" :rules="T_LibelleRules" label="Libellé" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="T_Valeur" :rules="T_ValeurRules" label="Valeur" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12"><v-checkbox v-model="L_defaultCondPmt" label="Condition de paiement par défaut" color="primary"></v-checkbox></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Annuler</v-btn>
          <v-btn color="blue darken-1" text @click="Fct_Save">Sauvegarder</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      L_id2: 0,
      T_Libelle: "",
      T_LibelleRules: [v => !!v || "Le libellé est obligatoire"],
      T_Valeur: "",
      T_ValeurRules: [v => !!v || "La valeur est obligatoire"],
      L_defaultCondPmt: 0
    };
  },
  methods: {
    show(id) {
      this.dialog = true;
      this.L_id2 = id;
      if (id != 0) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .get("preferences/" + id + "/", { headers: { Authorization: T_Token } })
          .then(TO_Response => {
            if (TO_Response != null) {
              this.T_Libelle = TO_Response.data.libelle;
              this.T_Valeur = TO_Response.data.value;
              this.L_defaultCondPmt = TO_Response.data.default;
            }
          })
          .catch(O_Error => {
            this.$root.$children[0].IsisInfo(" Problème DB - " + O_Error.message, "error");
          });
      } else {
        this.T_Libelle = "";
        this.T_Valeur = "";
        this.L_defaultCondPmt = 0;
      }
    },
    Fct_Save() {
      if (this.Fct_CheckData()) {
        let O_FormData = new FormData();
        let T_Key = "CondPmt_" + this.T_Libelle;
        O_FormData.append("key", T_Key);
        O_FormData.append("libelle", this.T_Libelle);
        O_FormData.append("value", this.T_Valeur);
        O_FormData.append("default", this.L_defaultCondPmt);
        if (this.L_id2 == 0) {
          var T_Token = "JWT " + this.$cookies.get("BackEndToken");
          this.$BackEndAPI
            .get("preferences/?key=" + T_Key, { headers: { Authorization: T_Token } })
            .then(TO_Response => {
              if (TO_Response != null) {
                var O_Data = TO_Response.data[0];
                if (O_Data != undefined) {
                  this.$root.$children[0].IsisInfo("La clé existe déjà !", "error");
                } else {
                  this.Fct_AddCondPmt(O_FormData);
                }
              }
            })
            .catch(O_Error => {
              this.$root.$children[0].IsisInfo("Could not save preference data" + O_Error.message, "error");
            });
        } else {
          //update record
          this.Fct_ModCondPmt(O_FormData);
        }
      }
    },
    Fct_CheckData() {
      if (this.T_Libelle == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner un libellé", "error");
        return false;
      }
      if (this.T_Valeur == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner une valeur", "error");
        return false;
      }
      return true;
    },
    Fct_AddCondPmt(O_FormData) {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .post("preferences/", O_FormData, { headers: { Authorization: T_Token } })
        .then(O_Response => {
          if (O_Response != null) {
            this.dialog = false;
            this.$parent.Fct_GetCondPmt();
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not add preference data" + O_Error.message, "error");
        });
    },
    Fct_ModCondPmt(O_FormData) {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .patch("preferences/" + this.L_id2 + "/", O_FormData, { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.dialog = false;
            this.$parent.Fct_GetCondPmt();
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not modify preference data" + O_Error.message, "error");
        });
    }
  }
};
</script>

<style scoped></style>
